<template>
  <div class="my-3 py-2 container-fluid">
    <button
      v-if="lastSeason"
      @click="showCreateForm"
      class="mb-3 btn btn-sm btn-outline-success"
    >
      {{ $t("parents.createParent") }}
    </button>
    <div class="row">
      <transition name="slide-fade" class="my-4">
        <form-create-parent
          v-if="isCreateParentVisible"
          @close="hideChild"
          @formSubmitted="parentCreated"
        />
      </transition>
      <div class="col-12">
        <parent-list
          :parents="parents"
          :lastSeason="lastSeason"
          :closeEditForm="closeEditForm"
          @close-edit-parent="fetchParents"
          @close-create-parent="hideChild"
          @reset-close-edit-form="resetCloseEditForm"
          @hide-pagination="hidePagination"
          @show-pagination="showPagination"
        />
      </div>
    </div>
    <span v-if="isPaginationVisible">
      <soft-pagination color="success" size="sm">
        <soft-pagination-item
          prev
          @click="prevPage"
          :disabled="currentPage === 1"
        />
        <div v-for="item in totalPages" :key="item">
          <soft-pagination-item
            v-if="item == currentPage"
            :label="currentPage"
            active
          />
          <soft-pagination-item
            v-if="item != currentPage"
            :label="item"
            @click="currPage(item)"
          />
        </div>
        <soft-pagination-item
          next
          @click="nextPage"
          :disabled="currentPage === totalPages"
        />
      </soft-pagination>
    </span>
  </div>
</template>

<script>
import axios from "axios";
import SoftPagination from "@/components/SoftPagination.vue";
import SoftPaginationItem from "@/components/SoftPaginationItem.vue";
import ParentList from "./components/ParentList";
import FormCreateParent from "@/components/FormCreateParent";

export default {
  name: "parents",
  components: {
    ParentList,
    SoftPagination,
    SoftPaginationItem,
    FormCreateParent,
  },
  data() {
    return {
      parents: [],
      currentPage: 1,
      totalPages: 1,
      isPaginationVisible: true,
      isCreateParentVisible: false,
      closeEditForm: false,
      lastSeason: false,
    };
  },
  created() {
    this.fetchParents();
  },
  methods: {
    async fetchParents(page = 1) {
      let response = await axios.get(`parents?page=${page}`);
      const parents = response.data.parents;
      this.parents = parents;
      this.currentPage = response.data.meta.current_page;
      this.totalPages = response.data.meta.last_page;
      this.lastSeason = response.data.last_season;
    },
    showCreateForm() {
      this.isCreateParentVisible = true;
      this.closeEditForm = !this.closeEditForm;
    },
    hideChild() {
      this.fetchParents();
      this.isCreateParentVisible = false;
    },
    parentCreated() {
      this.isCreateParentVisible = false;
      this.fetchParents();
    },
    resetCloseEditForm() {
      this.closeEditForm = false;
    },
    hidePagination() {
      this.isPaginationVisible = false;
    },
    showPagination() {
      this.isPaginationVisible = true;
    },
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
        this.fetchParents(this.currentPage);
      }
    },
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.fetchParents(this.currentPage);
      }
    },
    currPage(item) {
      this.currentPage = item;
      this.fetchParents(item);
    },
  },
};
</script>
